import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryLoanModel } from '../../models/summary-loan.model';


export enum LoanActionTypes {
  LoadLoans = '[Loan] Load Loans',
  LoadLoansSuccess = '[Loan] Load Loans Success',
  LoadLoansFailure = '[Loan] Load Loans Failure',

  LoadLoan = '[Loan] Load Loan',
  LoadLoanSuccess = '[Loan] Load Loan Success',
  LoadLoanFailure = '[Loan] Load Loan Failure',

  CreateLoan = '[Loan] Create Loan',
  CreateLoanSuccess = '[Loan] Create Loan Success',
  CreateLoanFailure = '[Loan] Create Loan Failure',

  UpdateLoan = '[Loan] Update Loan',
  UpdateLoanSuccess = '[Loan] Update Loan Success',
  UpdateLoanFailure = '[Loan] Update Loan Failure',

  DeleteLoan = '[Loan] Delete Loan',
  DeleteLoanSuccess = '[Loan] Delete Loan Success',
  DeleteLoanFailure = '[Loan] Delete Loan Failure',
}

/** Load all */

export class LoadLoans implements Action {
  readonly type = LoanActionTypes.LoadLoans;
  constructor(public payload: {filter: any}) {}
}

export class LoadLoansSuccess implements Action {
  readonly type = LoanActionTypes.LoadLoansSuccess;
  constructor(public payload: { items: SummaryLoanModel[]; total: number }) {}
}

export class LoadLoansFailure implements Action {
  readonly type = LoanActionTypes.LoadLoansFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadLoan implements Action {
  readonly type = LoanActionTypes.LoadLoan;
  constructor(public payload: { uid: string }) {}
}

export class LoadLoanSuccess implements Action {
  readonly type = LoanActionTypes.LoadLoanSuccess;
  constructor(public payload: SingleResponseModel<SummaryLoanModel>) {}
}

export class LoadLoanFailure implements Action {
  readonly type = LoanActionTypes.LoadLoanFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateLoan implements Action {
  readonly type = LoanActionTypes.CreateLoan;
  constructor(public payload: { loan: SummaryLoanModel }) {}
}


export class CreateLoanSuccess implements Action {
  readonly type = LoanActionTypes.CreateLoanSuccess;
  constructor(public payload: { loan: SummaryLoanModel }) {}
}

export class CreateLoanFailure implements Action {
  readonly type = LoanActionTypes.CreateLoanFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateLoan implements Action {
  readonly type = LoanActionTypes.UpdateLoan;
  constructor(public payload: { loan: SummaryLoanModel }) {}
}

export class UpdateLoanSuccess implements Action {
  readonly type = LoanActionTypes.UpdateLoanSuccess;
  constructor(public payload: { loan: SummaryLoanModel }) {}
}

export class UpdateLoanFailure implements Action {
  readonly type = LoanActionTypes.UpdateLoanFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteLoan implements Action {
  readonly type = LoanActionTypes.DeleteLoan;
  constructor(public payload: { uid: string }) {}
}

export class DeleteLoanSuccess implements Action {
  readonly type = LoanActionTypes.DeleteLoanSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteLoanFailure implements Action {
  readonly type = LoanActionTypes.DeleteLoanFailure;
  constructor(public payload: { error: any }) {}
}

export type LoanActions =
  | LoadLoans
  | LoadLoansSuccess
  | LoadLoansFailure
  | LoadLoan
  | LoadLoanSuccess
  | LoadLoanFailure
  | CreateLoan
  | CreateLoanSuccess
  | CreateLoanFailure
  | UpdateLoan
  | UpdateLoanSuccess
  | UpdateLoanFailure
  | DeleteLoan
  | DeleteLoanSuccess
  | DeleteLoanFailure
